/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ImportJobMetadataFromJSON, ImportJobMetadataToJSON, ImportJobSourceFromJSON, ImportJobSourceToJSON, ImportJobStatusFromJSON, ImportJobStatusToJSON, } from './';
export function ImportJobRepresentationFromJSON(json) {
    return ImportJobRepresentationFromJSONTyped(json, false);
}
export function ImportJobRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        description: json['description'],
        status: ImportJobStatusFromJSON(json['status']),
        metadata: ImportJobMetadataFromJSON(json['metadata']),
        source: ImportJobSourceFromJSON(json['source']),
        farseerFileId: json['farseerFileId'],
        createdAt: new Date(json['createdAt']),
        labels: json['labels'],
        creatorId: json['creatorId'],
    };
}
export function ImportJobRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        title: value.title,
        description: value.description,
        status: ImportJobStatusToJSON(value.status),
        metadata: ImportJobMetadataToJSON(value.metadata),
        source: ImportJobSourceToJSON(value.source),
        farseerFileId: value.farseerFileId,
        createdAt: value.createdAt.toISOString().substr(0, 10),
        labels: value.labels,
        creatorId: value.creatorId,
    };
}
